import React, { useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import axios from 'axios';

function Chat() {
  const [messages, setMessages] = useState([
    { sender: 'bot', text: 'أهلاً بك! كيف يمكنني مساعدتك؟' }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { sender: 'user', text: input };
    setMessages([...messages, userMessage]);
    setLoading(true);

    try {
      const res = await axios.post('https://api.example.com/chat', { message: input });
      const botReply = { sender: 'bot', text: res.data.reply };

      setMessages(prev => [...prev, botReply]);
    } catch (err) {
      setMessages(prev => [...prev, { sender: 'bot', text: 'حدث خطأ أثناء الاتصال بالخادم' }]);
    }

    setInput('');
    setLoading(false);
  };

  return (
    <div className="container mt-5" style={{ maxWidth: '600px' }}>
      <h4 className="text-center mb-4">الدردشة</h4>
      <div className="border p-3 mb-3" style={{ height: '300px', overflowY: 'auto' }}>
        {messages.map((msg, index) => (
          <div key={index} className={`mb-2 text-${msg.sender === 'user' ? 'end' : 'start'}`}>
            <span className={`badge bg-${msg.sender === 'user' ? 'primary' : 'secondary'}`}>
              {msg.text}
            </span>
          </div>
        ))}
      </div>

      <InputGroup>
        <Form.Control
          placeholder="اكتب رسالتك..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
        />
        <Button variant="danger" onClick={sendMessage} disabled={loading}>
          {loading ? '...جاري' : 'إرسال'}
        </Button>
      </InputGroup>
    </div>
  );
}

export default Chat;
